import { render } from "./Beverages.vue?vue&type=template&id=24072132&scoped=true"
import script from "./Beverages.vue?vue&type=script&lang=js"
export * from "./Beverages.vue?vue&type=script&lang=js"

import "./Beverages.vue?vue&type=style&index=0&id=24072132&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24072132"]])

export default __exports__